var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ref, computed } from "vue";
import Web3 from "web3";
import store from "@/store";
export var fuckContract = function (address, ERC20ABI, withSigner) {
    //@ts-ignore
    var web3 = new Web3(window.ethereum);
    var account = ref(null);
    var contract = computed(function () {
        if (address && ERC20ABI && web3.currentProvider) {
            return new web3.eth.Contract(ERC20ABI, address);
        }
        else {
            return null;
        }
    });
    var loadAccount = function () { return __awaiter(void 0, void 0, void 0, function () {
        var accounts;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, window.ethereum.request({
                        method: "eth_requestAccounts",
                    })];
                case 1:
                    accounts = _a.sent();
                    account.value = accounts[0];
                    return [2 /*return*/, accounts[0]];
            }
        });
    }); };
    var checkMetamaskIsAvailable = function () {
        //@ts-ignore
        var isMetamaskInstalled = ref(!!window.ethereum);
        if (!isMetamaskInstalled.value) {
            throw new Error("No suitable wallets found. Please install a wallet to continue.");
        }
    };
    var checkNetwork = function () { return __awaiter(void 0, void 0, void 0, function () {
        var chainId, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, window.ethereum.request({ method: "eth_chainId" })];
                case 1:
                    //@ts-ignore
                    chainId = _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    err_1 = _a.sent();
                    //@ts-ignore
                    console.error("Failed to fetch network id:", err_1);
                    throw new Error("Failed to fetch network id");
                case 3:
                    if (parseInt(chainId, 16).toString() !== store.getters.getSelectedChain.chainId.toString()) {
                        throw new Error("Incorrect network. Please switch to the ".concat(store.getters.getSelectedChain.chainName, " network"));
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var sendTransaction = function (methodName, methodArguments) { return __awaiter(void 0, void 0, void 0, function () {
        var method, response, err_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 4, , 5]);
                    if (!withSigner) return [3 /*break*/, 2];
                    method = contract.value.methods[methodName]({
                        value: methodArguments,
                    });
                    return [4 /*yield*/, window.ethereum.request({
                            method: "eth_sendTransaction",
                            params: [
                                {
                                    from: account.value,
                                    value: methodArguments,
                                    to: contract.value.options.address,
                                    data: method.encodeABI(),
                                },
                            ],
                        })];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response];
                case 2:
                    alert("Please provide a signer");
                    throw new Error("Please provide a signer");
                case 3: return [3 /*break*/, 5];
                case 4:
                    err_2 = _a.sent();
                    //@ts-ignore
                    alert(err_2.message);
                    //@ts-ignore
                    console.error(err_2.message);
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    // watch([address, ERC20ABI], loadAccount);
    return {
        contract: contract,
        loadAccount: loadAccount,
        sendTransaction: sendTransaction,
        checkNetwork: checkNetwork,
        checkMetamaskIsAvailable: checkMetamaskIsAvailable,
    };
};
